import Vue from 'vue';
import rules from "src/config/rule-config.js";
import {insertAfter} from "src/control/common.js";

function getvalue(obj,index){   //获取dom的值
    // return obj.newValue[index];
    let input = getInput(obj.children[index]);
    return obj.newValue[index] || ( input?input.value:"");
}

function getArg(el){  //获取参数
    let data_arg = el["data-arg"];

    if( data_arg== undefined){
        return undefined;
    }

    if(data_arg instanceof Array == false){  //不是数组
        return data_arg;
    }

    if(data_arg.length>1){  //是数组的话
        return data_arg;
    }else{
        return data_arg[0];
    }
}

function createTip(){  //创造提示dom
    let divDom = document.createElement("div");
    divDom.className = "z-tip";
    return divDom;
}

function insertTip(el){  //插入tip
    let par = el.parentNode;
    if(par && par.classList.contains("z-group") ){
        let list = par.getElementsByClassName("z-tip");
        if(list.length == 0){
            insertAfter(createTip(),el);
        }
        return;
    }
    insertAfter(createTip(),el);
}

function getGroup(){  //是否分组了

}

function getText(el){  //拿到提示文字dom
    el = el.$el || el;
    let par = el.parentNode;
    if(par && par.classList.contains("z-group")){
        return el.parentNode.getElementsByClassName("z-tip")[0];
    }
    return el.nextElementSibling;
}

function getInput(el){  //拿到真正的表单dom
    el = el.$el || el;
    let lowerStr = el.tagName.toLowerCase();
    if(lowerStr == "input" || lowerStr == "textarea"){
        return el;
    }
    let input =  el.getElementsByTagName("input");
    let textarea = el.getElementsByTagName("textarea");
    let resDoms = input.length?input:
                textarea.length?textarea:"";

    if(resDoms == ""){   //自身不是表单  同时不包含表单 
        return el;
    }

    if(resDoms.length == 1){
        return resDoms[0];
    }else{
        for(let i =0,len=resDoms.length;i<len;i++){
            if(resDoms[i].className.indexOf("el-input__inner") != -1){
                return resDoms[i];
            }
        }
    }
}

function showError(el,error){ //展示错误
    let text = getText(el);
    text.innerText = error;
    try{
        getInput(el).classList.add("formError");
    }catch(err){
        console.log(getInput(el));
    }
    text.classList.add("formErrorTip");

}
 
function hideError(el){   //隐藏错误
    // console.log(el);
    let text = getText(el);
    let input = getInput(el);
    // console.log(text);
    text && text.classList.remove("formErrorTip");
    // console.log(input);
    input && input.classList.remove("formError");
}



function getForm(el){  //获取表单对象
    if(FormControl.only.dom && FormControl.only.dom.contains(el)){
        return FormControl.only;
    }
    for(let name in FormControl.forms){
        if(FormControl.forms[name] && FormControl.forms[name].dom.contains(el)){
            return FormControl.forms[name];
        }
    }
    // console.log(FormControl);
    return false;
}

function getIndex(el,parent){  //获取当前的dom值
    let res = -1;
    parent.children.some((dom,index)=>{
        if(dom === el){
            res = index;
            return true; 
        }
    });
    return res;
}

function arrdiff(arr1,arr2){  //数组比较  不相等返回true
    // console.log(arr1);
    // console.log(arr2);
    if(!(arr1 instanceof Array) || !(arr2 instanceof Array)){
        return true;
    }
    
    if(arr1.length != arr2.length){
        return true;
    }else if(arr1.length == 0){
        return false;
    }

    return arr1.some((val,index)=>{
        return val != arr2[index];
    });

}

function changeJudge(obj,index){  //数据比对
    // if(!oldarr[index]){
    //     oldarr[index] = newarr[index];
    //     return;
    // }
    let oldarr = obj.oldValue;
    let newarr = obj.newValue;

    if( arrdiff(oldarr[index],newarr[index]) && oldarr[index] != newarr[index]){
        obj.changeFlag = true;
        return;
    }

    obj.changeFlag = oldarr.some((val,index) => {
        return arrdiff(val,newarr[index]) && val != newarr[index];
    });
}



// function pushChild(el,value){  //添加子元素
//     let obj = getForm(el);

//     if(obj){
//         obj.children.push(el);  //添加dom
//         obj.oldValue.push(value); //添加初值
//         obj.newValue.push(value); //添加初值
//         insertAfter(createTip(),el);

//         el.onfocus = function(){
//             hideError(el);
//         }
//         return true;
//     }
//     return false;
// }

const FormControl = {
    rules:rules,
    forms:{},
    only:{},  //没有命名空间的放这里
    breakFlag:false,  //跳过保存验证
    // router: $router,   //在main.js  把路由塞进来了
    // window_pop: new windowPop(),//在main.js  把遮罩塞进来了

    
    createForm(name,el,vm){  //注册一个表单
        
        let obj = {
            counter:0,  //作为unbind的依据
            dom:el,
            children:[],
            changeFlag:false,
            oldValue:[],
            newValue:[],
        };

        if(name){ 
            this.forms[name] && (obj.counter++);
            this.forms[name] = obj;
        }else{
            this.only = obj;
        }

    },
    unbindForm(name){
        if(name && this.forms[name].counter==0 ){
            this.forms[name] = null;
        }
    },
    add(el,value){  //表单添加审查条目/赋初值
        console.log("insert");
        let obj = getForm(el);
        if(obj){
            obj.children.push(el);  //添加dom
            if(Array.isArray(value)){
                obj.oldValue.push([...value]); //添加初值
                obj.newValue.push([...value]); //添加初值
            }else{
                obj.oldValue.push(value); //添加初值
                obj.newValue.push(value); //添加初值
            }
            insertTip(el);
            // insertAfter(createTip(),el);
            let input = getInput(el);
            if(input){
                input.addEventListener("focus",function(){
                    hideError(el);
                });
            }
        }
        // console.log(obj);
    },
    delete(el){   //删除表单项
        console.log("delete");
        let index;
        let obj;
        if(this.only.children){
            this.only.children.some((dom,i)=>{
                return dom == el && (index=i);
            });
        }

        for(let name in this.forms){
            if(this.forms[name] && this.forms[name].children){
                this.forms[name].children.some((dom,i)=>{
                    return dom == el && (index=i);
                });
                if(index!=undefined){
                    obj = this.forms[name];
                }
            }
        }
        if(obj){
            obj.children.splice(index,1);
            obj.oldValue.splice(index,1);
            obj.newValue.splice(index,1);
        }
    },
    updateVal(el,newVal){  //更新表单值
        console.log("修改");
        // console.log(newVal);
        // console.log(el)
        let obj = getForm(el);
        let index = getIndex(el,obj);
        obj.newValue.splice(index,1,newVal);
        
        changeJudge(obj,index);
        // console.log(obj);
        // console.log(this);
    },

    updateArg(el,val){   //更新参数值
        el["data-arg"] = val;
    },
    init(name){  //更新表单初始值
        console.log("更新初始值");
        setTimeout(()=>{
            let obj = name?this.forms[name]:this.only;
            let oldarr = obj.oldValue;
            obj.newValue.forEach((val,index) => {
                if(Array.isArray(val)){
                    oldarr[index] = [...val];
                }else{
                    oldarr[index] = val;
                }
            });
            obj.changeFlag = false;
        },0)
    },
    reBack(name){  //还原修改
        let obj = name?this.forms[name]:this.only;
        let oldarr = obj.oldValue;
        // let newarr = obj.newValue;

        // oldarr.forEach((val,index) => {
        //     getInput(obj.children[index]).value = val+"";            
        //     newarr[index] = val;
        // });
        // obj.changeFlag = false;
        return [...oldarr];
    },
    leave(){  // 退出自验证
        if(this.breakFlag == true){
            this.breakFlag = false;
            return;
        }

        let name;
        let path;
        let judge;
        let _this = this;
        switch(typeof arguments[0]){
            case "string":
            path = arguments[0];
            break;

            case "object":
            name = arguments[0].name;
            path = arguments[0].path;
            break;
        }
        judge = arguments[1];

        let obj = name?this.forms[name]:this.only;
        let router = this.router; //拿到路由控制器
        // console.log(obj);
        // console.log(path);
        if(obj.changeFlag || judge){
            this.window_pop.show();
            this.window_pop.func = function(){
                _this.breakFlag = true;
                router.push(path);
            };
            return false;
        }

        return;
    },
    clear(name){  //去除报错效果
        let obj = name?this.forms[name]:this.only;
        obj && obj.children.forEach(el=>{
            hideError(el);
        });
    },
    check(name){  //验证
        let obj = name?this.forms[name]:this.only;
        let errorLen = 0;
        // console.log(obj);
        for(let i = 0,len = obj.children.length;i<len;i++){
            let el = obj.children[i]; //dom
            let ruleStr = el.getAttribute("rule");
            let rule_arr = [];
            // console.log(ruleStr);

            // 处理规则列表
            if(typeof ruleStr == "object"){

            }else{
                ruleStr && (rule_arr = ruleStr.split(" "));
            }
            
            let value = getvalue(obj,i);  //获取值
            let arg = getArg(el);    //获取额外参数
            // console.log(`value: ${value}`);

            for(let x of rule_arr){
                let error = this.rules[x].call(this,value,arg);
                // console.log(`error : ${error}`);
                if(error!==false){
                    // console.log("***error*** 错误");
                    // console.log(`error value: ${value}`);
                    // console.log(`error arg: ${arg}`);

                    showError(el,error);
                    errorLen++;
                    break;
                }
            }
        }

        if(errorLen){  //报错
            return false
        };
        return true;

    },
    hideError, //隐藏错误
}

export default FormControl;


/****自定义指令***************/ 
Vue.directive('group',{
    bind(el){
        console.log("group");
        el.classList.add("z-group");
    }
});

Vue.directive('tar', {
    inserted: function (el, binding, vnode) {
        FormControl.add(el,binding.value);
    },
    update:function(el,binding){
        let newVal = binding.value;
        let oldVal = binding.oldValue;
        // console.log(`newVal:${newVal}  oldVal:${oldVal}`);
        // console.log(`相等 ：${newVal === oldVal}`)
        // console.log("update");
        if( Array.isArray(newVal)){
            console.log("数组更新")
            // console.log(el);
            // console.log(newVal)
            FormControl.updateVal(el,[...newVal]);
        }else if( newVal !== oldVal ){
            console.log("正常更新")
            FormControl.updateVal(el,newVal);
        }
    },
    unbind(el){
        FormControl.delete(el);
    },
    // componentUpdated:function(el,binding){
    //     if(binding.value != binding.oldValue){
    //         FormControl.updateVal(el,binding.value);
    //     }
    // },
});

Vue.directive('arg', {
    inserted: function (el, binding, vnode) {
        // console.log(binding.value);
        FormControl.updateArg(el,binding.value)
    },
    update: function (el, binding, vnode) {
        FormControl.updateArg(el,binding.value)
    }
});

Vue.directive('form', {
    bind: function (el, binding, vnode) {
        let name = binding.arg || binding.value;
        // console.log(name);
        console.log(`bind: ${name}`);
        if(name == false){
            return;
        }
        FormControl.createForm(name,el,vnode.context);
    },
    unbind(el, binding, vnode){
        // 后续的优化  及时释放内存，清空对象
        let name = binding.arg || binding.value;
        console.log(`unbind: ${name}`);
        FormControl.unbindForm(name);
    }
});


// WEBPACK FOOTER //
// ./src/control/formCheck.js